import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { digObject } from 'functions/utilities'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')

const filterCaseStudies = (caseStudies, filters, selectedCaseStudyIds) => {
  const { limit, offset } = filters || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  const filteredCaseStudies = selectedCaseStudyIds.length
    ? Object.values(caseStudies).filter(caseStudy => selectedCaseStudyIds.includes(caseStudy.id))
    : Object.values(caseStudies)

  const limited = filterLimit
    ? filteredCaseStudies.slice(filterOffset, filterLimit)
    : filteredCaseStudies.slice(filterOffset)

  return limited
}

const renderCaseStudies = (campaigns, caseStudies, caseStudyContainer, images) => caseStudies.map((caseStudy) => {
  const campaign = campaigns[caseStudy.campaign] || {}
  const custom_data = digObject(caseStudy, 'data.custom_data', [])
  const caseStudyAddress = digObject(caseStudy, 'data.address', {})
  const caseStudyImage = images[caseStudy.image] || {}

  const default_image = campaign.default_image || caseStudyImage.large_url || ''

  const caseStudyContext = {
    ...campaign,
    ...caseStudy,
    ...caseStudyAddress,
    custom_data,
    default_image,
  }

  return (
    <div key={caseStudy.id} style={deviceStyle(caseStudyContainer)}>
      <ElementContainer
        forwardContextToItems={caseStudyContext}
        section={caseStudyContainer}
        renderNested
        render={({ itemComponents }) => itemComponents.map(component => component)}
      />
    </div>
  )
})

const CaseStudies = (props) => {
  const {
    callbacks: { registerActiveComponent },
    data,
    items,
    options,
  } = props

  const { shortcode } = data || {}

  const { limit, offset } = options || {}

  const caseStudyContainer = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const {
    activeComponents,
    dataSource,
  } = defaultContext

  const { campaigns, caseStudies, images } = useSelector(reduxState => reduxState.entities)

  const selectedCaseStudyIds = digObject(dataSource, 'options.case_study_ids', [])

  const filteredCaseStudies = filterCaseStudies(caseStudies, { limit, offset }, selectedCaseStudyIds)

  if (!filteredCaseStudies.length) return null

  if (shortcode && !activeComponents[shortcode]){
    registerActiveComponent(shortcode, { count: filteredCaseStudies.length })
  }

  return (
    <AnimationWrapper options={options}>
      <div style={style}>{renderCaseStudies(campaigns, filteredCaseStudies, caseStudyContainer, images)}</div>
    </AnimationWrapper>
  )
}

CaseStudies.propTypes = {
  callbacks: PropTypes.shape({
    registerActiveComponent: PropTypes.func.isRequired,
  }),
  data: PropTypes.object,
  items: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
}

export default CaseStudies
